import VoyageInformation from "./VoyageInformation/VoyageInformation";
import VesselReportingInfo from "./VesselReportingInfo/VesselReportingInfo";
import DeckOfficerWizard from "./ReportingWizard/DeckOfficerReport/DeckOfficerReporting";
import EngineerWizard from "./ReportingWizard/EngineerReport/EngineerReporting";
import VesselMachinerySettings from "./VesselMaster/VesselConfiguration/VesselConfiguration";
import VesselAdditionalInformation from "./VesselMaster/AdditionalInformation/AdditionalInformation";
import VesselPerformance from 'VesselPerformance/VesselPerformance';
import { Roles } from "./shared/constants";
import React, { Suspense, lazy } from "react";
import DashboardFleet from "Dashboard/DashboardFleet";
import STSAdjustment from "Adjustments/STSAdjustment/STSAdjustment";
import FCeboAdjustment from "Adjustments/FCeboAdjustment/FCeboAdjustment";
import VoyageAdjustment from "Adjustments/VoyageAdjustment/VoyageAdjustment";
import N2Adjustment from "Adjustments/N2Adjustment/N2Adjustment";
import { getAuthData } from "utils/auth/authUtils";
import SyncReport from "SyncReport/SyncReport";
import Notification from "Notification/Notification";
import FuelEUAnalysis from "FuelEU/FuelEUAnalysis";
import Pooling from "Pooling/Pooling";
import PoolingVessels from "Pooling/PoolingVessels";
import PoolingList from "Pooling/PoolingList";
import OrganizationConfiguration from "OrganizationConfiguration/OrganizationConfiguration";
import Users from "Users/Users";
import ProfileSetting from "Header/TopbarDropdown/ProfileSetting";
import CreateVesselReport from "VesselReportingInfo/CreateVesselReport";
import Help from "Header/TopbarDropdown/Help/Help";
import PortMasterUpdate from "Components/PortMasterUpdate";
import ImportUsers from "Users/importUser/ImportUsers";
import ImportHistory from "Users/ImportHistory/ImportHistory";
import ViewHistory from "Users/ImportHistory/ViewHistory";
import LoadingLogo from "loadingLogo";
import FleetManagement from "Fleets/FleetManagement";
import CompanyCustonReport from './ReportGeneration/CompanyCustomReport';
import FinalAdjustment from "Adjustments/FinalAdjustment/FinalAdjustment";
import EuMrvGenerationFilters from "EuMrvEts/EuMrvGenerationFilter";
import OtherPort from "otherPort/OtherPort";
import OffhireByVessel from "Offhire/OffhireByVessel";
import { SensorStatus } from "HorizontalMenu/SensorStatus";
import VesselMap from "Vessel Mapping/vesselMapping";
import ROBData from "ROBData/ROBData";
import AllUploadedFiles from "AllUploadedFiles";
interface RouteProps {
  path: string;
  component?: any;
  exact?: boolean;
  allowedRole?: string[]
}

const CIIAssessment = lazy(() => import('CIIAssessment/CIIAssessment'));
const CIISimulator = lazy(() => import('Simulator/CIIProjection/CIISimulator'));
const EuMrvEts = lazy(() => import('./EuMrvEts/EuMrvEts'));
const VoyageEstimator = lazy(() => import('Simulator/VoyageEstimator/VoyageEstimator'));
const Fleets = lazy(() => import('Fleets/FleetsAssesment'));
const GenericIndex = lazy(() => import('./GenericForms/Generic.index'));
const ImoDcs = lazy(() => import('ImoDcs.tsx/ImoDcs'));
const CustomReportGeneration = lazy(() => import(`ReportGeneration/CustomReport`));
const UkMrv = lazy(() => import('UkMrv/UkMrv'));
const VesselMaster = lazy(() => import('./VesselMaster/VesselMaster'));
const Dashboard = lazy(() => import('./Dashboard/Dashboard'));
const About = lazy(() => import('./About/About'));
const CheckUpdate = lazy(() => import('./About/CheckUpdate'));

const masters = [
  'region_master',
  'hull_type_master',
  'beaufort_scale_master',
  'contact_type_master',
  'port_master',
  'vessel_owner_details',
  'country_master',
  'vessel_load_condition_master',
  'wind_direction_master',
  'unit_group_master',
  'unit_master',
  'vessel_type_master',
  'vessel_sub_type_master',
  'fuel_type_master',
  'fuel_master',
  'fuel_sub_type_master',
  'fuel_class_master',
  'reporting_operation_mode_master',
  'reporting_events_master',
  'reporting_type_master',
  'current_direction_master',
  'machinery_list_master',
  'vessel_machinery_list',
  'vessel_sensors_list',
  'lube_oil_list_master',
  'vessel_lube_oil_list',
  'reporting_events_list_master',
  'vessel_reporting_events_list',
  'douglas_sea_scale_master',
  'vessel_owner_details',
  'strait_canal_transit_list_master',
  'cii_adjustment_events_master',
  'vessel_owner_details',
]
const userRoutes: Array<RouteProps> = [
  //Generic Master
  ...masters.map((master: any) => {
    return ({
      path: `/masters/${master}`,
      component:
        <Suspense
          fallback={<LoadingLogo />}>
          <GenericIndex />
        </Suspense >,
      allowedRole: [Roles.ES_ADMIN]
    })
  }),
  {
    path: "/reporting/voyage_reporting",
    component: <VoyageInformation />,
    allowedRole: [Roles.MASTER, Roles.ES_ADMIN, Roles.CHIEFENGINEER, Roles.ADMIN]
  },
  {
    path: "/reporting/vessel_reporting",
    exact: true,
    component: <VesselReportingInfo />,
    allowedRole: [Roles.MASTER, Roles.CHIEFENGINEER, Roles.ES_ADMIN, Roles.ADMIN]
  },
  {
    path: "/reporting/deck_officer_reporting",
    exact: true,
    component: <DeckOfficerWizard />,
    allowedRole: [Roles.MASTER, Roles.ES_ADMIN, Roles.ADMIN]
  },
  {
    path: "/reporting/engineer_reporting",
    exact: true,
    component: <EngineerWizard />,
    allowedRole: [Roles.CHIEFENGINEER, Roles.ES_ADMIN, Roles.ADMIN]
  },
  {
    path: "/masters/vessel_reporting",
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <VesselMaster
          operation='vessel_reporting'
        />
      </Suspense>,
    allowedRole: [Roles.ES_ADMIN, Roles.MASTER, Roles.MANAGER, Roles.CHIEFENGINEER, Roles.ADMIN]
  },
  {
    path: '/dashboard',
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <Dashboard />
      </Suspense>,
    allowedRole: [Roles.MANAGER, Roles.MASTER, Roles.CHIEFENGINEER, Roles.ES_ADMIN, Roles.ADMIN]
  },
  {
    path: "/dashboard_fleet",
    component: <DashboardFleet />,
    allowedRole: [Roles.MANAGER, Roles.ES_ADMIN, Roles.ADMIN]
  },
  {
    path: "/fleet_assessment",
    component:
      <Suspense fallback={<LoadingLogo />}>
        <Fleets />
      </Suspense>,
    allowedRole: [Roles.MANAGER, Roles.ES_ADMIN, Roles.ADMIN]
  },
  {
    path: "/fleet_management",
    component: <FleetManagement />,
    allowedRole: [Roles.MANAGER, Roles.ES_ADMIN, Roles.ADMIN]
  },
  {
    path: "/cii_assessment",
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <CIIAssessment />
      </Suspense>,
    allowedRole: [Roles.MANAGER, Roles.ES_ADMIN, Roles.ADMIN]
  },
  {
    path: "/imo_dcs",
    component: <Suspense
      fallback={<LoadingLogo />}>
      <ImoDcs />
    </Suspense>,
    allowedRole: [Roles.MANAGER, Roles.ES_ADMIN, Roles.ADMIN]
  },
  {
    path: "/eu_mrv_ets",
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <EuMrvEts />
      </Suspense>,
    allowedRole: [Roles.MANAGER, Roles.ES_ADMIN, Roles.ADMIN]
  },
  {
    path: "/uk_mrv",
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <UkMrv />
      </Suspense>,
    allowedRole: [Roles.MANAGER, Roles.ES_ADMIN, Roles.ADMIN]
  },
  {
    path: "/vessel_performance",
    component: <VesselPerformance />,
    allowedRole: [Roles.MANAGER, Roles.ES_ADMIN]
  },
  {
    path: "/vessel_configuration",
    component: <VesselMachinerySettings />,
    allowedRole: [Roles.ES_ADMIN]
  },
  {
    path: "/vessel_additional_information",
    component: <VesselAdditionalInformation />,
    allowedRole: [Roles.ES_ADMIN]
  },
  {
    path: "/profile_details",
    component: <ProfileSetting />,
    allowedRole: [Roles.ES_ADMIN, Roles.MANAGER, Roles.CHIEFENGINEER, Roles.MASTER, Roles.ADMIN]
  },
  {
    path: '/testing',
    component: <PortMasterUpdate />,
    allowedRole: [Roles.ES_ADMIN]
  },
  {
    path: '/cii_simulator',
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <CIISimulator />
      </Suspense>,
    allowedRole: [Roles.ES_ADMIN, Roles.ADMIN]
  },
  {
    path: '/voyage_estimator',
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <VoyageEstimator />
      </Suspense>,
    allowedRole: [Roles.ES_ADMIN]
  },
  {
    path: '/custom_report_generation',
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <CustomReportGeneration />
      </Suspense>,
    allowedRole: [Roles.ES_ADMIN, Roles.ADMIN]
  },
  {
    path: '/custom_company_report',
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <CompanyCustonReport />
      </Suspense>,
    allowedRole: [Roles.ES_ADMIN, Roles.MANAGER, Roles.ADMIN]
  },
  {
    path: '/sensor_status',
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <SensorStatus />
      </Suspense>,
    allowedRole: [Roles.ES_ADMIN, Roles.MANAGER, Roles.ADMIN]
  },
  {
    path: '/voyage_adjustment',
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <VoyageAdjustment />
      </Suspense>,
    allowedRole: [Roles.MASTER, Roles.ES_ADMIN, Roles.MANAGER, Roles.ADMIN]
  },
  {
    path: '/sts_adjustment',
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <STSAdjustment />
      </Suspense>,
    allowedRole: [Roles.MASTER, Roles.ES_ADMIN, Roles.MANAGER, Roles.ADMIN]
  },
  {
    path: '/FC(elec+boiler+other)_adjustment',
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <FCeboAdjustment />
      </Suspense>,
    allowedRole: [Roles.ES_ADMIN, Roles.ADMIN]
  },
  {
    path: '/final_adjustment',
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <FinalAdjustment />
      </Suspense>,
    allowedRole: [Roles.MASTER, Roles.ES_ADMIN, Roles.MANAGER]
  },
  {
    path: '/n2_correction',
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <N2Adjustment />
      </Suspense>,
    allowedRole: [Roles.MASTER, Roles.ES_ADMIN, Roles.MANAGER, Roles.ADMIN]
  },
  {
    path: '/sync_report',
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <SyncReport />
      </Suspense>,
    allowedRole: [Roles.MASTER, Roles.ES_ADMIN, Roles.MANAGER, Roles.ADMIN]
  },
  {
    path: '/notifications',
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <Notification />
      </Suspense>,
    allowedRole: [Roles.MASTER, Roles.ES_ADMIN, Roles.MANAGER, Roles.CHIEFENGINEER, Roles.ADMIN]
  },
  {
    path: '/fuel_eu',
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <FuelEUAnalysis />
      </Suspense>,
    allowedRole: [Roles.ES_ADMIN, Roles.MANAGER, Roles.ADMIN]
  },
  {
    path: '/notifications/:id',
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <Notification />
      </Suspense>,
    allowedRole: [Roles.MASTER, Roles.ES_ADMIN, Roles.MANAGER, Roles.CHIEFENGINEER, Roles.ADMIN]
  },
  {
    path: '/pooling',
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <Pooling />
      </Suspense>,
    allowedRole: [Roles.ES_ADMIN]
  },
  {
    path: '/pooling_vessels',
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <PoolingVessels />
      </Suspense>,
    allowedRole: [Roles.ES_ADMIN]
  },
  {
    path: '/pooling_list',
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <PoolingList />
      </Suspense>,
    allowedRole: [Roles.ES_ADMIN]
  },
  {
    path: '/onboarding',
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <VesselMaster
          operation='onboarding'
        />
      </Suspense>,
    allowedRole: [Roles.ES_ADMIN, Roles.MANAGER, Roles.MASTER]
  },
  {
    path: "/org_config", exact: true,
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <OrganizationConfiguration />
      </Suspense>,
    allowedRole: [Roles.ES_ADMIN, Roles.MANAGER]
  },
  {
    path: "/users",
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <Users />
      </Suspense>,
    allowedRole: [Roles.MANAGER, Roles.ES_ADMIN]
  },
  {
    path: "/create_report_testing",
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <CreateVesselReport />
      </Suspense>,
    allowedRole: [Roles.ES_ADMIN]
  },
  { path: "/", exact: true, component: <Dashboard /> },
  {
    path: "/help",
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <Help />
      </Suspense>,
    allowedRole: [Roles.ES_ADMIN, Roles.MANAGER, Roles.CHIEFENGINEER, Roles.MASTER, Roles.ADMIN]
  },
  {
    path: "/check_update",
    component: <Suspense
      fallback={<LoadingLogo />}>
      <CheckUpdate />
    </Suspense>,
    allowedRole: [Roles.MANAGER, Roles.ES_ADMIN, Roles.MASTER, Roles.CHIEFENGINEER, Roles.ADMIN]
  },
  {
    path: "/about",
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <About />
      </Suspense>,
    allowedRole: [Roles.MANAGER, Roles.ES_ADMIN, Roles.MASTER, Roles.CHIEFENGINEER, Roles.ADMIN]
  },
  {
    path: 'users/imports',
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <ImportUsers />
      </Suspense >,
    allowedRole: [Roles.ES_ADMIN]
  },
  {
    path: 'users/history',
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <ImportHistory />
      </Suspense >,
    allowedRole: [Roles.ES_ADMIN]
  },
  {
    path: 'users/history/1',
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <ViewHistory />
      </Suspense >,
    allowedRole: [Roles.ES_ADMIN]
  },
  {
    path: "eu_mrv_ets/generation",
    component: (
      <Suspense
        fallback={<LoadingLogo />}>
        <EuMrvGenerationFilters />
      </Suspense>
    ),
    allowedRole: [Roles.ES_ADMIN, Roles.MASTER, Roles.CHIEFENGINEER, Roles.ADMIN],
  },
  {
    path: '/other_port',
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <OtherPort />
      </Suspense>,
    allowedRole: [Roles.ES_ADMIN]
  },
  {
    path: '/off_hire_management',
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <OffhireByVessel />
      </Suspense>,
    allowedRole: [Roles.ES_ADMIN, Roles.ADMIN]
  },
  {
    path: '/rob_data',
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <ROBData />
      </Suspense>,
    allowedRole: [Roles.ES_ADMIN, Roles.ADMIN]
  },
  {
    path: '/vessel_mapping',
    component:
      <Suspense
        fallback={<div className="lazy-load-component"></div>}>
        <VesselMap />
      </Suspense>,
    allowedRole: [Roles.ES_ADMIN]
  },
  {
    path: '/uploaded_files',
    component:
      <Suspense
        fallback={<LoadingLogo />}>
        <AllUploadedFiles />
      </Suspense>,
    allowedRole: [Roles.ES_ADMIN, Roles.MANAGER, Roles.MASTER, Roles.ADMIN]
  },
];

/**
 * Filter out roles which are applicable to the role based on session
 */
const roles = getAuthData('roles') ?? [];
const userAllowedRoutes = userRoutes.filter((route: any) =>
  route?.allowedRole?.some((item: any) =>
    item === roles[0]?.role_constant   // Online logic
  )
) ?? [];
export { userAllowedRoutes };